<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0478 15.0538L6.39404 9.4L7.44779 8.34625L12.0478 12.9463L16.6478 8.34625L17.7015 9.4L12.0478 15.0538Z" fill="currentColor"/>
</svg>
